import { VendorLiveListEntity } from '@/types/live-lists'

/**
 * The vendor number a rollup config or exclusion is stored against. Not every
 * accounting system exposes an external vendor id — Ajera, for one, leaves it
 * unset — so the live list's own `entity_id` identifies the vendor there.
 */
export default function getVendorNum(vendor: VendorLiveListEntity): string {
  return vendor.external_vendor_id || vendor.entity_id
}
